import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/teacherService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";


class TeacherForm extends Form {
  state = {
   
    imageUrl : "",
    data: {
      name: "",
      designation: "",
      description: ""
    },
    
    errors: {}
  };

  schema = {
    id: Joi.string(),
    name: Joi.string()
    .required()
    .label("Name"),
    designation: Joi.string()
      .required()
      .label("Designation"),
    description: Joi.string()
      .required()
      .label("Description")
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });
    
      let formData = new FormData();
      formData.append("name", this.state.data.name);
      formData.append("designation", this.state.data.designation);
      formData.append("description", this.state.data.description);
      formData.append("image", this.state.imageUrl);
      
      await saveSingle(formData);

      toast.success("Teacher has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/web/teachers");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  
  onChangeImage = e => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/bank.png";
    const { editorState } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <TableTitle title="Add Teacher" icon="tag" color="white" iconPath={dashboardIcon} />
        <center>
          <form
            onSubmit={this.handleSubmit}
            className="ui error form"
            style={{ width: "70%" }}
          >
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">Add Teacher</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderInput("name", "Name", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderInput("designation", "Designation", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderTextarea("description", "Description", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                      <label>
                        Image
                      </label>
                      <input
                        className="input_imagem_artigo"
                        type="file"
                        onChange={this.onChangeImage}
                      />
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>
                    {this.renderButton("Save")}
                    <Link to="/web/teachers" className="ui secondary button">
                      Back
                    </Link>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </form>
        </center>
      </BlockUi>
    );
  }
}

export default TeacherForm;
